export enum OrderEventsEnum {
  Purchase = 'purchase',
}

export enum OrderDeliveryTypeEnum {
  HOMEDELIVERY = 'homedelivery',
  BOPIS = 'bopis',
  SEVEN_ELEVEN = 'seveneleven',
  WALKIN = 'walkin',
  KERRY = 'kerry',
  EASY_DELIVERY = 'easydeliverypoint',
}

export const ORDER_DELIVERY_TYPES: { [key: string]: Array<string> } = {
  [OrderDeliveryTypeEnum.HOMEDELIVERY]: [OrderDeliveryTypeEnum.HOMEDELIVERY],
  [OrderDeliveryTypeEnum.BOPIS]: [
    OrderDeliveryTypeEnum.BOPIS,
    OrderDeliveryTypeEnum.SEVEN_ELEVEN,
    OrderDeliveryTypeEnum.WALKIN,
    OrderDeliveryTypeEnum.KERRY,
    OrderDeliveryTypeEnum.EASY_DELIVERY,
  ],
};

export const ADJUSTMENTS_CREDIT_VOUCHER = 'CreditVoucher';

export enum PackageDeliveryEventEnum {
  PACKAGE_COMPLETED = 'PACKAGE_COMPLETED',
  PACKAGE_OUT_FOR_DELIVERY = 'PACKAGE_OUT_FOR_DELIVERY',
  PACKAGE_PREPARING = 'PACKAGE_PREPARING',
  READY_FOR_COLLECTION = 'READY_FOR_COLLECTION',
  PACKAGE_UNDELIVERED = 'PACKAGE_UNDELIVERED',
}

export const SalesOrderChannelEnum = {
  Web: 'Web',
  CommerceWeb: 'Commerce Web',
  CustomerService: 'Customer Service',
  RecurringOrder: 'Recurring Order',
  Subscription: 'Subscription',
  POS: 'Point of Sale',
  CommerceApp: 'Commerce App',
  BodyKey: 'Body Key',
  DMS: 'DMS',
  Line: 'Line',
  WebMobile: 'Web Mobile',
  TMS: 'TMS',
};

export enum BundleTypesEnums {
  POOL = 'POOL',
  VARIANT = 'VARIANT',
  FIXED = 'FIXED',
}

export enum CalculatedOrderStatus {
  ORDER_UNDELIVERED = 'ORDER_UNDELIVERED',
  ORDER_PREPARING = 'ORDER_PREPARING',
  READY_FOR_COLLECTION = 'READY_FOR_COLLECTION',
}

export enum CalculatedDisplayStatus {
  ORDER_SHIPPED = 'OrderShipped',
  PAYMENT_NOT_REQUIRED = 'PaymentNotRequired',
  PAYMENT_PENDING = 'PaymentPending',
  ZERO_VALUE_ORDER = 'ZeroValueOrder',
}
